import React from 'react';
import { Skeleton } from '@material-ui/lab';

export function ActivityTimelineItemSkeleton() {
  return <Skeleton variant='rect' width='100%' height='130px' style={{ borderRadius: '8px', marginTop: '1rem' }} />;
}
